// extracted by mini-css-extract-plugin
export default {"targetContainer":"CareElementsConfiguration_targetContainer__DR8Xf"};